module.exports = __webpack_public_path__ + "img/20-2.58f1e655.png";